/////// DANGER ///////////////////////////////
// Be careful using this in multiple places //
//////////////////////////////////////////////

var Chronometer = {

	duration: 0,
	referenceDate: null,
	init: function() {
		Chronometer.duration = 0;
		Chronometer.referenceDate = new Date();
	},
	getDuration: function() {
		if (Chronometer.referenceDate) {
			var delta = new Date() - Chronometer.referenceDate;
			return (delta + Chronometer.duration) / 1000;
		} else {
			return Chronometer.duration;
		}
	},
	start: function() {
		if (!Chronometer.referenceDate) {
			Chronometer.referenceDate = new Date();	
		}
	},
	pause: function() {
		Chronometer.duration = Chronometer.getDuration();
		Chronometer.referenceDate = null;	
	},
	reset: function() {
		Chronometer.duration = 0;
		Chronometer.referenceDate = new Date();
	},
}

module.exports = Chronometer;




// WEBPACK FOOTER //
// ./modules/lib/interface/Chronometer.js